import { render, staticRenderFns } from "./NewCustomer.vue?vue&type=template&id=083f03fc&scoped=true&"
import script from "./NewCustomer.vue?vue&type=script&lang=ts&"
export * from "./NewCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./NewCustomer.vue?vue&type=style&index=0&id=083f03fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083f03fc",
  null
  
)

export default component.exports